import * as React from 'react';
import {
    Route, Switch,
    withRouter
} from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Containers from '../container';
import LoadingFrame from '../components/LoadingFrame';

@observer
class Routes extends React.Component<any> {
    componentWillMount() {
        this.props.authStore.verifySession();
    }

    render(): React.ReactNode {
        if (this.props.commonStore.appLoaded) {
            return (
                <Containers.Layout>
                    <Switch>
                        <Route exact key="root" path="/" component={Containers.Home}/>
                        {([] as any[]).concat(Containers.RoutingData.map(route => {
                                return route.paths.map((path, index) => {
                                    return (
                                        <Route
                                            key={index}
                                            path={`${path}/:currentId?/:operation?/:state?`}
                                            component={route.component}
                                        />
                                    );
                                });
                            })
                        )}
                    </Switch>
                </Containers.Layout>
            );
        } else {
            return <LoadingFrame type="pac" />;
        }
    }
}

export default inject('authStore', 'commonStore')(withRouter(Routes)) as typeof Routes;



// WEBPACK FOOTER //
// ./src/routes/MainRoutes.tsx